// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CriteriaFilters_wrapper__3VEeo","criteriaGrid":"CriteriaFilters_criteriaGrid__1exPg","criteriaColumn":"CriteriaFilters_criteriaColumn__34Lvn"};